





























import { Vue, Component, Prop } from 'vue-property-decorator'
import { Project } from '@/data/projects'

import 'semantic-ui-css/components/segment.min.css'
import 'semantic-ui-css/components/grid.min.css'

@Component
export default class LCProject extends Vue {
  @Prop() readonly prj!: Project
}
